module.exports = __webpack_public_path__ + "img/join_bg.e62efe56.jpg";